import {
  IJudgeOption,
  IScoreCardDiscipline,
} from '../../../../../models/event-fees/event-fees.interface'

import { dummySheets } from '../../data/sheets'

export const disciplineOptions: IJudgeOption[] = [
  { label: 'Time/Score', value: 'Time/Score', disable: false },
  { label: 'Dressage', value: 'Dressage', disable: false },
  { label: 'Eventing', value: 'Eventing', disable: true },
  { label: 'Hunter Jumper', value: 'Hunter Jumper', disable: false },
  { label: 'AQHA', value: 'AQHA', disable: true },
  { label: 'Reining', value: 'Reining', disable: true },
]

const scoreCardTimeOptions: IJudgeOption[] = [
  { label: 'Time/Score ranked', value: 'Default', disable: false },
]

export const scoreCardOptions: IJudgeOption[] = [
  { label: 'Default', value: 'Default', disable: false },
  { label: 'Test of Choice', value: 'test-of-choice', disable: false },
  ...dummySheets.map((sheet) => ({
    label: sheet.name,
    value: sheet.id,
    disable: false,
  })),
]

export const getJudgeValues = (field: string | null, options: IJudgeOption[]) => {
  return field
    ? {
        value: options.find((sheet) => sheet.value === field)?.value ?? '',
        label: options.find((sheet) => sheet.value === field)?.label ?? '',
        disable: options.find((sheet) => sheet.value === field)?.disable ?? false,
      }
    : null
}

export const getScoreCardsValues = ({
  discipline,
  scoreCardHunterJumperOptions,
}: {
  discipline?: IScoreCardDiscipline
  scoreCardHunterJumperOptions: IJudgeOption[]
}) => {
  return discipline === 'Time/Score'
    ? scoreCardTimeOptions
    : discipline === 'Dressage'
      ? scoreCardOptions
      : discipline === 'Hunter Jumper'
        ? scoreCardHunterJumperOptions
        : []
}
